import type { CartItemData } from '../hooks/useAllUserMultiCartItemsMetadata'
import { sum } from 'lib/array/arrayUtils'
import { getUserCartItemDisplayTotals } from 'lib/userCart/userCartTotals'
import { sumBundledExperienceShareForParent } from 'checkout/lib/utils/accommodation/bundledExperienceTotals'
import { isExperienceItem, isTransferItem } from 'lib/checkout/checkoutUtils'

export function getMultiCartGroupPublicTotal(
  multiCartItems: Array<App.MultiCartItem>,
  cartItemsData: Array<CartItemData>,
  allMultiCartItems: Array<App.MultiCartItem>,
): number | undefined {
  const activeItemIds = new Set(
    multiCartItems
      .filter(item => item.state === 'active')
      .map(item => item.item.itemId),
  )

  if (activeItemIds.size === 0) {
    return
  }

  const groupCartItemsData = cartItemsData.filter(item => (
    activeItemIds.has(item.itemId) &&
    !item.isSavedForLater &&
    !item.isDeleted
  ))

  if (groupCartItemsData.length !== activeItemIds.size || groupCartItemsData.some(item => !item.itemTotals)) {
    return
  }

  const bundledChildren = allMultiCartItems
    .filter(mci => mci.state === 'active')
    .map(mci => mci.item)
    .filter(item => isExperienceItem(item) || isTransferItem(item))
    .filter(item => !!item.isAccomBundle && !!item.bundledItemIds?.length)
    .map(item => ({
      total: item.total,
      bundledItemIds: item.bundledItemIds,
    }))

  return sum(groupCartItemsData, item => {
    const baseTotal = getUserCartItemDisplayTotals(item.itemTotals).publicTotal
    const bundledShare = item.isAccomBundle
      ? sumBundledExperienceShareForParent(bundledChildren, item.itemId)
      : 0
    return baseTotal + bundledShare
  })
}
